import {Dispatch, SetStateAction, useState} from 'react';

const rot13 = (str: string) => {
  return str.replace(/[a-z]/gi, l => String.fromCharCode(l.charCodeAt(0) + (l.toLowerCase() <= 'm' ? 13 : -13)));
}

const useLocalStorage = <T>(storageKey: string, fallbackState: T, obfuscate?: boolean, raw?: boolean): [T, Dispatch<SetStateAction<T>>, () => void] => {
  let defaultValue: T;
  try {
    let storageValue = window.localStorage.getItem(storageKey);
    if (storageValue && obfuscate) {
      storageValue = atob(rot13(storageValue));
    }
    if (raw && typeof storageValue) {
      defaultValue = (storageValue ?? fallbackState) as T;
    } else {
      defaultValue = JSON.parse(storageValue ?? '') ?? fallbackState
    }
  } catch {
    defaultValue = fallbackState;
  }

  const [value, setValueState] = useState<T>(defaultValue);

  const setValue = (value: T) => {
    if (value === null) {
      localStorage.removeItem(storageKey);
      return;
    }
    let storageValue: string;
    if (raw) {
      storageValue = value as string;
    } else {
      storageValue = JSON.stringify(value);
    }
    if (obfuscate) {
      storageValue = rot13(btoa(storageValue));
    }
    localStorage.setItem(storageKey, storageValue);
    setValueState(value);
  }

  const removeItem = () => {
    localStorage.removeItem(storageKey)
  }

  return [value, setValue, removeItem];
};

export default useLocalStorage;
